import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JioMeetingsService } from "../_services/jio-meetings.service";
import { AlertService } from "../_services";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { EncryptionService } from "../_services/encryption.service";
import { ExcelService } from "../_services/excel.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";

declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-mentorship-provided-by-mentee",
  templateUrl: "./mentorship-provided-by-mentee.component.html",
})
export class MentorshipProvidedByMenteeComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger = new Subject();
  closeResult: string;
  menteeName: any;
  start: number = 0;
  pageLength: number = 10;
  mentorName: any;
  dynamicRating: any;
  dynamic_rating: any;
  feedBackList: any = [];
  mentorshipList: any[] = [];
  exprtJioMeetList: any = [];
  mentorshipTotal: any;
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;
  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;

  constructor(
    public router: Router,
    private dataService: JioMeetingsService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private http: HttpClient,
    private excelService: ExcelService,
    private enc_dec: EncryptionService
  ) {}

  menteeFeedBack = {
    created_at: "",
    created_by: "",
    feedback: "",
    feedback_by: "",
    feedback_by_id: "",
    id: "",
    meeting_id: "",
    rating: "",
  };

  mentorFeedBack = {
    created_at: "",
    created_by: "",
    feedback: "",
    feedback_by: "",
    feedback_by_id: "",
    id: "",
    meeting_id: "",
    rating: "",
  };

  ngOnInit() {
    this.getAllInviteMember();
    window.scroll(0, 0); // this.loadHide();
    this.jiomeetList();
  }

  getAllInviteMember() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      order: [[7, "desc"]], // Default sorting on "status"
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;
        this.http
          .post<DataTablesResponse>(
            "/api/jio-meet-list",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters))
              ),
            },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            resp.data.forEach((item: any) => {
              item.Mentor_Meeting_Duration = this.convertTime(
                item.Mentor_Meeting_Duration
              );
              item.Mentee_Meeting_Duration = this.convertTime(
                item.Mentee_Meeting_Duration
              );
            });

            this.mentorshipList = resp["data"];
            this.mentorshipTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [{ data: "id" }, { data: "mentee_name" }, { data: "duration" }],
    };
  }

  convertTime(timeString: any) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  getRowNumber(index: number): number {
    return this.start + index + 1;
  }

  jiomeetList() {
    this.loadShow();
    this.dataService
      .exportJiomeetList()
      .pipe()
      .subscribe((res) => {
        if (res.status == 200) {
          this.exprtJioMeetList = res["data"];
          this.fieldsToIncludeExcel = [
            "topic",
            "mentor_name",
            "mentee_name",
            "Mentor_Meeting_Duration",
            "Mentee_Meeting_Duration",
            "created_at",
            "status",
          ];
          this.exl = true;
        }
        this.loadHide();
      });
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exprtJioMeetList,
      this.fieldsToIncludeExcel,
      "Mentorship Provided By Mentee"
    );
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
